module.exports = __webpack_public_path__ + "static/img/img_chanpincx_001.3f8ce32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_chanpincx_001.png
// module id = DMSS
// module chunks = 19